import { Unit } from '../../../../instructor/units.service';

/** Shown when a unit reaches the player without a usable name (KAN-655). */
export const UNTITLED_UNIT_NAME = 'Untitled unit';

/**
 * The name every player surface shows for a unit (header, unit intro card,
 * sidebar group, course summary). Falls back to `title`, then to a neutral
 * label, so a payload missing `name` can never print "undefined - Overview".
 */
export function unitDisplayName(unit: Partial<Unit> | null | undefined): string {
  const name = unit?.name ?? (unit as { title?: string } | null | undefined)?.title;
  return typeof name === 'string' && name.trim() ? name : UNTITLED_UNIT_NAME;
}
